/**
 * Lampenwerk24 – Card Carousel / Variant Swipe
 * Touch-Swipe (Mobile) + Arrow-Navigation (Desktop)
 * Aktualisiert Card-Link auf aktive Variante
 * Wobble-Hint auf erstem Karussell
 * Slider-Bar Fortschrittsanzeige
 *
 * Voraussetzung: card-product.liquid mit data-lw-carousel Attribut
 */
(function () {
  'use strict';

  /* -------------------------------------------------- */
  /*  Konfiguration                                      */
  /* -------------------------------------------------- */
  var SWIPE_THRESHOLD = 30;          // px – Mindest-Swipe zum Slide-Wechsel
  var SWIPE_CLICK_TOLERANCE = 8;     // px – darunter zählt es als Tap/Klick

  /* -------------------------------------------------- */
  /*  Bereits initialisierte Karusselle tracken          */
  /* -------------------------------------------------- */
  var initializedSet = new WeakSet();

  /* -------------------------------------------------- */
  /*  Initialisierung                                    */
  /* -------------------------------------------------- */
  function initCarousels() {
    var carousels = document.querySelectorAll('[data-lw-carousel]');
    if (!carousels.length) return;

    // Prüfe ob es das erste sichtbare (nicht-initialisierte) Karussell ist
    var firstNew = true;
    for (var i = 0; i < carousels.length; i++) {
      if (!initializedSet.has(carousels[i])) {
        setupCarousel(carousels[i], firstNew);
        initializedSet.add(carousels[i]);
        firstNew = false;
      }
    }
  }

  /* -------------------------------------------------- */
  /*  Ein einzelnes Karussell aufsetzen                  */
  /* -------------------------------------------------- */
  function setupCarousel(el, isFirst) {
    var track     = el.querySelector('.lw24-carousel-track');
    var slides    = el.querySelectorAll('.lw24-carousel-slide');
    var prevBtn   = el.querySelector('[data-lw-arrow="prev"]');
    var nextBtn   = el.querySelector('[data-lw-arrow="next"]');
    // Wrapper für Card-Link und Slider
    var wrapper   = el.closest('.lw24-card-wrapper');
    var cardLink  = wrapper ? wrapper.querySelector('.lw24-card-link') : null;

    // Slider ist Sibling des Carousels innerhalb .card
    var sliderBar = el.parentElement ? el.parentElement.querySelector('.lw24-slider-bar') : null;
    var slider    = sliderBar ? sliderBar.querySelector('.lw24-slider-thumb') : null;
    var count     = parseInt(el.getAttribute('data-slide-count'), 10) || slides.length;

    // Varianten-URLs (Komma-getrennt)
    var urlsRaw   = el.getAttribute('data-variant-urls') || '';
    var urls      = urlsRaw.split(',');

    // Varianten-IDs (Komma-getrennt)
    var idsRaw    = el.getAttribute('data-variant-ids') || '';
    var ids       = idsRaw.split(',');

    var current   = 0;
    var isSwiping = false;

    // Slider-Breite berechnen
    var thumbWidth = 100 / count;

    /* --- Slide navigieren --- */
    function goTo(index) {
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      current = index;

      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      // Slider-Bar aktualisieren (Position via left %)
      if (slider) {
        slider.style.width = thumbWidth + '%';
        slider.style.left = (current * thumbWidth) + '%';
      }

      // Card-Link auf Variante aktualisieren
      if (cardLink && urls[current]) {
        cardLink.setAttribute('href', urls[current]);
      }
    }

    /* --- Arrow-Buttons (Klick darf nicht zum Card-Link bubblen) --- */
    function onArrowClick(e) {
      e.preventDefault();
      e.stopPropagation();
      var dir = this.getAttribute('data-lw-arrow');
      if (dir === 'prev') {
        goTo(current - 1);
      } else {
        goTo(current + 1);
      }
    }

    if (prevBtn) {
      prevBtn.style.pointerEvents = 'auto';
      prevBtn.addEventListener('click', onArrowClick);
    }
    if (nextBtn) {
      nextBtn.style.pointerEvents = 'auto';
      nextBtn.addEventListener('click', onArrowClick);
    }

    /* --- Klick auf Carousel-Bild → Navigiere zur Variante --- */
    /* Da das Carousel jetzt über dem <a>-Link liegt (z-index: 26 > 25),
       müssen wir Klicks auf die Bilder selbst abfangen und navigieren */
    el.addEventListener('click', function (e) {
      // Nicht navigieren wenn auf Arrow, Quick-Add oder während Swipe geklickt
      if (e.target.closest('[data-lw-arrow]')) return;
      if (e.target.closest('.lw24-quick-add-container')) return;
      if (isSwiping) return;

      // Navigiere zur aktuellen Variante
      var targetUrl = urls[current] || (cardLink ? cardLink.getAttribute('href') : null);
      if (targetUrl) {
        window.location.href = targetUrl;
      }
    });

    /* --- Touch-Swipe --- */
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDeltaX = 0;
    var isHorizontalSwipe = null;

    el.addEventListener('touchstart', function (e) {
      // Wobble-Klasse entfernen sobald der User interagiert
      el.classList.remove('lw24-wobble-once');

      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDeltaX = 0;
      isHorizontalSwipe = null;
      isSwiping = false;

      // Transition während des Swipens deaktivieren
      track.classList.add('lw24-no-transition');
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      // Entscheiden: horizontal oder vertikal?
      if (isHorizontalSwipe === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
        isHorizontalSwipe = Math.abs(dx) > Math.abs(dy);
      }

      if (!isHorizontalSwipe) return; // Vertikales Scrollen zulassen

      e.preventDefault(); // Horizontalen Swipe greifen
      touchDeltaX = dx;
      isSwiping = Math.abs(dx) > SWIPE_CLICK_TOLERANCE;

      // Live-Feedback: Track mitziehen
      var offset = -(current * 100);
      var pxPercent = (dx / el.offsetWidth) * 100;
      track.style.transform = 'translateX(' + (offset + pxPercent) + '%)';
    }, { passive: false });

    el.addEventListener('touchend', function () {
      track.classList.remove('lw24-no-transition');

      if (isHorizontalSwipe && Math.abs(touchDeltaX) > SWIPE_THRESHOLD) {
        if (touchDeltaX < 0) {
          goTo(current + 1);  // nach links gewischt → nächstes
        } else {
          goTo(current - 1);  // nach rechts gewischt → vorheriges
        }
      } else {
        // Zurückschnappen
        goTo(current);
      }

      touchDeltaX = 0;
      isHorizontalSwipe = null;

      // isSwiping nach kurzem Delay zurücksetzen,
      // damit der Klick-Handler nach Swipe nicht navigiert
      setTimeout(function () {
        isSwiping = false;
      }, 80);
    }, { passive: true });

    /* --- Wobble-Hint auf erstem Karussell --- */
    if (isFirst) {
      el.classList.add('lw24-wobble-once');
      // Nach der Animation Klasse entfernen
      var onAnimEnd = function () {
        el.classList.remove('lw24-wobble-once');
        track.removeEventListener('animationend', onAnimEnd);
      };
      track.addEventListener('animationend', onAnimEnd);
    }

    /* --- Keyboard-Navigation (wenn fokussiert) --- */
    el.setAttribute('tabindex', '0');
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(current - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(current + 1);
      }
    });

    // Initial: Slider-Bar auf erstes Slide setzen
    goTo(0);
  }

  /* -------------------------------------------------- */
  /*  DOMContentLoaded + dynamisches Nachladen           */
  /* -------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  // Falls Shopify Sections per AJAX nachgeladen werden (z.B. Collection-Filter)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initCarousels, 100);
  });

  // Infinite scroll / "Mehr laden" – MutationObserver
  var gridObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        var hasNewCarousel = false;
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1 && (node.querySelector && node.querySelector('[data-lw-carousel]'))) {
            hasNewCarousel = true;
            break;
          }
        }
        if (hasNewCarousel) {
          setTimeout(initCarousels, 50);
          break;
        }
      }
    }
  });

  // Beobachte das <main> Element für neue Produkt-Cards
  var mainEl = document.querySelector('main') || document.body;
  gridObserver.observe(mainEl, { childList: true, subtree: true });

})();